export const getUserRole = () => {
  try {
    const userData = localStorage.getItem("role");
    return userData;
  } catch (error) {
    console.error(`Error getting localStorage item`);
  }
};
